(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mitt"), require("A11yDialog"));
	else if(typeof define === 'function' && define.amd)
		define([, ], factory);
	else if(typeof exports === 'object')
		exports["A11yConsent"] = factory(require("mitt"), require("A11yDialog"));
	else
		root["A11yConsent"] = factory(root["mitt"], root["A11yDialog"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__218__, __WEBPACK_EXTERNAL_MODULE__612__) => {
return 